import { MarkdownPreview } from '../../custom-components';
import {
  EntityDrawerSection,
  ACTIONS_POSITION,
  type EntityDrawerSectionProps,
  type ActionsPosition,
} from './EntityDrawerSection';
import { Box } from '@terra/ui-styled-system';

type EntityDrawerSectionMarkdownProps = Omit<
  EntityDrawerSectionProps,
  'children'
> & {
  value: string;
  actions?: EntityDrawerSectionProps['actions'];
  /** Where to render actions. Default NextToTitle. Pass Opposite for end alignment (e.g. Web). */
  actionsPosition?: ActionsPosition;
};

export const EntityDrawerSectionMarkdown = ({
  title,
  value,
  actions,
  actionsPosition = ACTIONS_POSITION.NextToTitle,
  ...props
}: EntityDrawerSectionMarkdownProps) => (
  <EntityDrawerSection
    title={title}
    actions={actions}
    actionsPosition={actionsPosition}
    {...props}
  >
    <Box w="full" color="fg.muted">
      <MarkdownPreview source={value} fontSize={14} />
    </Box>
  </EntityDrawerSection>
);
